import { Component, ComponentInterface, Element, h, Host, Prop, State } from '@stencil/core';
import {
  TITLE_ALIGNMENTS,
  TITLE_SIZES,
  TITLE_SPACINGS_Y,
  TitleAlignment,
  TitleColors,
  TitleSize,
  TitleSpacingY,
  VisualTitleHtmlTag,
} from './models/title.types';

@Component({
  tag: 'wink-title',
  styleUrl: 'styles/title.default.scss',
  scoped: true,
})
export class Title implements ComponentInterface {
  @Element() host!: HTMLWinkTitleElement;

  @Prop() htmlTag: TitleSize = TITLE_SIZES.h2;
  @Prop() visualTag: VisualTitleHtmlTag;
  @Prop() noSeo = false;
  @Prop() text? = '';
  @Prop() spacingY: TitleSpacingY = TITLE_SPACINGS_Y.default;
  @Prop() isFlowRendition = false;
  @Prop() alignment: TitleAlignment = TITLE_ALIGNMENTS.left;
  @Prop() titleColor?: TitleColors;

  @State() _HtmlTag: TitleSize = this.htmlTag;

  componentWillRender(): void {
    this._HtmlTag = this.noSeo ? ('div' as TitleSize) : this.htmlTag;
  }

  determineComputedTag(): TitleSize {
    return (this.visualTag as TitleSize) || this.htmlTag;
  }

  render() {
    return (
      <Host
        class={{
          [this.spacingY !== 'default' ? `spacing-${this.spacingY}` : '']: true,
          ['is-flow-rendition']: this.isFlowRendition,
          ['color--' + this.titleColor]: this.titleColor !== undefined,
          ['alignment-' + this.alignment]: this.alignment !== undefined,
        }}>
        <this._HtmlTag class={this.determineComputedTag()}>{this.text ? this.text : <slot />}</this._HtmlTag>
      </Host>
    );
  }
}
